module.exports = __webpack_public_path__ + "img/areas-verdes.4c822493.svg";